import { forwardRef } from "react";
import Icon from "../../icons/Icon.web";
import Box, { type BoxProps } from "../../layout/Box/Box.web";

const InputClearButton: React.FC<BoxProps> = forwardRef<
  HTMLDivElement,
  BoxProps
>(function forwardButtonRef({ role, ...props }: BoxProps, ref) {
  return (
    <Box
      display="flex"
      cursor="pointer"
      justifyContent="center"
      alignItems="center"
      borderRadius="50px"
      p="2xs"
      {...props}
      ref={ref}
      role={role || "button"}
      color="gray.500"
      _hover={{ backgroundColor: "gray.300" }}
    >
      <Icon.X.Outline height="element.md" width="element.md" />
    </Box>
  );
});

export default InputClearButton;
